import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_CONTACTUS_DATA, FETCH_CONTACTUS_EDIT_DATA } from "./actionTypes";
import {
  fetchContactUsSuccess,
  fetchContactUsFailure,
  fetchContactUsEditSuccess,
  fetchContactUsEditFailure,
} from "./actions";

function* fetchContactUsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/contact-us",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchContactUsSuccess(response.data));
  } catch (error) {
    yield put(fetchContactUsFailure(error.message));
  }
}

function* fetchContactUsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/ContactUs/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchContactUsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchContactUsEditFailure(error.message));
  }
}

export default function* contactUsSaga() {
  yield takeEvery(FETCH_CONTACTUS_DATA, fetchContactUsDataSaga);
  yield takeEvery(FETCH_CONTACTUS_EDIT_DATA, fetchContactUsEditDataSaga);
}
